module.exports = __webpack_public_path__ + "img/9788971847695.e0d41dba.jpg";